import { render, staticRenderFns } from "./PageTypeA.vue?vue&type=template&id=808584ba&"
import script from "./PageTypeA.vue?vue&type=script&lang=js&"
export * from "./PageTypeA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports